import { defineStore } from 'pinia';
// import websiteInfo from '~/assets/json/website-info.json';

export const useWebsiteInfoStore = defineStore('websiteInfo', {
  state: () => ({
    website: {},
    footerArticles: [],
    partners: [],
    ads: [],
  }),
  actions: {
    async fetchWebsiteInfo() {
      try {
        const response = await fetch(
          useNuxtApp().$apiUrl + '/api/website-info'
        );
        const responseJson = await response.json();
        this.website = responseJson.website;

        // const responseJson = websiteInfo;

        // // Get the hostname (domain)
        // const domain = window.location.hostname;

        // // Get the port
        // const port = window.location.port;

        // // Combine domain and port, but ignore port if it's 80
        // const domainWithPort =
        //   domain + (port && port !== '80' ? ':' + port : '');

        // this.website = responseJson.websites.find(
        //   (website) =>
        //     website.frontend_domain === domainWithPort ||
        //     website.dev_frontend_domain === domainWithPort
        // );
        this.footerArticles = responseJson.footer_articles;
        this.partners = responseJson.partners;

        this.ads = responseJson.ads || [];
      } catch (error) {
        console.error('API call failed:', error);
      }
    },
    updateWebsiteInfoFromBroadcast(websites) {
      this.website = websites.find(
        (w) => w.coin_slug === this.website.coin_slug
      );
    },
  },
  getters: {
    websiteInfo: (state) => state.website,

    getAdByTimeRotation: (state) => (type) => {
      const enabledAds = state.ads.filter(
        (ad) => ad.type === type && ad.enabled
      );

      if (enabledAds.length === 0) return null;
      if (enabledAds.length === 1) return enabledAds[0];

      // Calculate hours since start of day
      const now = new Date();
      const startOfDay = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );
      const hoursFromStartOfDay = (now - startOfDay) / (1000 * 60 * 60); // Convert to hours

      // Calculate how many hours each ad should be displayed
      const hoursPerAd = 24 / enabledAds.length;

      // Determine which ad should be shown now
      const currentAdIndex =
        Math.floor(hoursFromStartOfDay / hoursPerAd) % enabledAds.length;

      return enabledAds[currentAdIndex];
    },

    mobileAd: (state) => {
      return state.getAdByTimeRotation('mobile');
    },

    desktopAd: (state) => {
      return state.getAdByTimeRotation('desktop');
    },
  },
});
